import { useSystemStore } from "@/stores/system/SystemStore";

export default function closeModals ({next}:any){
    const systemStore = useSystemStore();

    systemStore.modal.contentObject = {};
    systemStore.modal.show = false;

    return next();
}
